import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_file_reader = _resolveComponent("file-reader")!
  const _component_new_modal = _resolveComponent("new-modal")!

  return (_openBlock(), _createBlock(_component_new_modal, {
    title: "Загрузить Акт об обнаружении недостатков/излишка/утраты",
    loading: _ctx.loading,
    onSubmit: _ctx.onSubmit,
    onCancel: _ctx.onCancel
  }, {
    default: _withCtx(() => [
      _createVNode(_component_file_reader, {
        placeholder: "Фото товара",
        value: _ctx.payload.productFiles,
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.payload.productFiles) = $event)),
        "is-invalid": _ctx.validation$.productFiles.$error,
        "validation-errors": _ctx.validation$.productFiles.$errors,
        multiple: ""
      }, null, 8, ["value", "is-invalid", "validation-errors"]),
      _createVNode(_component_file_reader, {
        class: "mt-2",
        placeholder: "Акт об обнаружении недостатков",
        value: _ctx.payload.shortcomingFiles,
        "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.payload.shortcomingFiles) = $event)),
        "is-invalid": _ctx.validation$.shortcomingFiles.$error,
        "validation-errors": _ctx.validation$.shortcomingFiles.$errors,
        multiple: ""
      }, null, 8, ["value", "is-invalid", "validation-errors"])
    ]),
    _: 1
  }, 8, ["loading", "onSubmit", "onCancel"]))
}